var map = {
	"./banana.png": 2906,
	"./bell.png": 4231,
	"./crossing.png": 2200,
	"./egg.png": 5456,
	"./flower.png": 2605,
	"./leaf.png": 7772,
	"./lightning.png": 4327,
	"./mushroom.png": 325,
	"./shell.png": 6005,
	"./special.png": 5847,
	"./star.png": 4551,
	"./triforce.png": 5805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3919;